
import { gql } from '@apollo/client/core'

export const categoryQuery = gql`
  query getCategoryDetailAndProduct ($id: ID!){
    category (id: $id) {
      id
      mainImage
      mainImageAlt
      detail
      categoryBanners {
        id
        image
        altText
        displayMethod
        destinationUrl
      }
    	childCategories {
        id
        url
        iconImage
        lowestPrice
        campaignLowestPrice
        shortDisplayName
        iconImageAlt
        quantityUnit
        lead
      }
    shortDisplayName
    shortestShippingDates {
      fullColor
      singleColor
    }
    categorySections{
      id
      sectionType
      iconImage
      tags {
        tagName
        id
        products(categoryId: $id){
          id
          productImage
          shortDisplayName
          quantityUnit
          mainImageAlt
          minPrice
          maxPrice
          minCampaignPrice
          maxCampaignPrice
          minProductQuantity
          maxProductQuantity
          printTag
          estimateItemId
        }
      }
      title
    }
    }
  }
`
export const facetCategoryQuery = gql`
  query getCategoryFacets(
    $categoryIds: [ID!]
    $offset: Int!
    $limit: Int!
    $categoryFacets: Boolean!
  ) {
    productSearchResults(
      categoryIds: $categoryIds
      offset: $offset
      limit: $limit,
      categoryFacets: $categoryFacets
    ) {
      facets {
        facetKeyName
        facetKeyId
        facetKeyDisplayName
        facetType
        canonicalSetting
        count
        facetKeyDisplayOrder
        facetKeyNumberOfFacetValuesDisplayedInRow
        facetValues {
          count
          facetValueName
          facetValueId
          facetValueDisplayOrder
          facetValueDisplayName
          facetValueImage
        }
      }
    }
  }
`
export const sortedProductsQuery = gql`
  query getProductsForCategoryPage(
    $categoryIds: [ID!]!
    $sortOrder: String!
    )
  {
    productsForCategoryPage(categoryIds: $categoryIds, sortOrder: $sortOrder) {
      total
      items {
        id
        productImage
        shortDisplayName
        quantityUnit
        mainImageAlt
        minPrice
        maxPrice
        minCampaignPrice
        maxCampaignPrice
        minProductQuantity
        maxProductQuantity
        printTag
        estimateItemId
      }
    }
  } `
